import Vue from 'vue';
import { api } from "../../services/Api.js";

export function add_news_item({ state }, payload ){

    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    

   
    // make api call
    return api
    .post(school,"add_news_item.php",payload)
    .then( result =>{ 
      // no toast here, waiting for image upload
      return result;
    })
    .catch( error => {
      Vue.$toaster.toast("store: add_news_item: "+error);
      return error;
    })

    
  }